<template>
  <div class="index">
    <Header :title="title" @func="getOpen" :imgSrc="imgSrc"></Header>
    <Top @func="getOpen"></Top>
    <div class="esLists">
      <Secondlists></Secondlists>
    </div>
    <div class="mask" @click="closeBox" v-show="maskShow">
      <div class="maskBox">
        <div class="top" @click="closeBox">电脑端该功能已打烊，请下载邻友圈App进行操作。</div>
        <div class="greenBox">
          <img class="ptitle" src="@/assets/imgs/txt.png" alt="">
          <div class="btBox">
            <img class="phone" src="@/assets/imgs/banner.png"/>
            <p class="title">好玩好看和超多有趣邻友一起分享身边事</p>
            <div class="codeBox">
              <p class="downtxt">扫码下载</p>
              <img src="@/assets/imgs/code.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import Top from './common/top.vue'
import Secondlists from './common/secondlists.vue'
export default {
  name: 'Index',
  components:{
    Header,
    Top,
    Secondlists,
    Footer
  },
  data () {
    return {
      title:'回到首页',
      maskShow:'',
      tableList:[],
      page:1,
      streetId:'',
      imgSrc:require('../assets/imgs/logo2.png')
    }
  },
  created() {
    document.title = '二手市场'
  },
  mounted() {
    if(this.$route.query.streetId) {
      localStorage.setItem('hstreetId',this.$route.query.streetId)
    }
  },
  methods:{
    getOpen(data) {
      this.maskShow = data
      document.querySelector('body').style.overflow = 'hidden'
    },
    closeBox() {
      this.maskShow = false
      document.querySelector('body').style.overflow = 'auto'
    },
  }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
  ::-webkit-scrollbar{
    width:0;
  }
  .el-pagination{
      clear: both;
      text-align: center;
      margin:65px 0 100px 0 !important;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
      background:#d8d8d8 !important;
  }
  .el-pagination.is-background .el-pager li{
      background:#d8d8d8 !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
      background:#95c847 !important;
  }
  .mask{
    width:100%;
    height: 100%;
    background: rgba(0,0,0,.7);
    left:0;
    top:0;
    position: fixed;
    .maskBox{
      width:1000px;
      background:#95c847;
      margin:150px auto;
      // position: absolute;
      // top:50%;
      // margin-top:-150px;
      .top{
        height:60px;
        font-size:@ft20;
        line-height: 60px;
        text-align:center;
        background:url("../assets/imgs/xl.png") no-repeat 960px center rgba(255,255,255,0.90);
        background-size:20px;
        cursor: pointer;
      }
      .greenBox{
        height: 500px;
        padding:20px 50px 0 40px;
        background:#95c847;
        border:1px solid #979797;
        .ptitle{
          display: block;
          width: 600px;
          margin:0 auto 30px;
        }
        .btBox{
          position: relative;
          .phone{
            width:480px;
            position: absolute;
          }
          .title{
            font-size:31px;
            position: absolute;
            left:300px;
            color:white;
            font-weight: 100;
          }
          .codeBox{
            position: absolute;
            right:110px;
            top:110px;
            font-size:@ft22;
            color:white;
            width: 200px;
            font-weight: 100;
            text-align: center;
            .downtxt{
              margin-bottom:20px;
            }
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/index.vue